import * as React from 'react';
import {FormEvent} from 'react';
import Button from "@components/common/button/Button";
import TranslateNew from "@translate/TranslateNew";
import {WithStyles, withStyles} from '@material-ui/core/styles';
import {GuideStyles} from '../guide.styles';
import {IFamilyMember} from "@app-types/websocket/family.types";
import ProgressBar from "@components/common/progressBar/progressBar";
import {Typography} from "@material-ui/core";
import CheckboxButton from "@components/common/checkboxButton/checkboxButton.component";
import { FamilyMemberType } from '@services/family/family.constants';

const tn: TranslateNew = TranslateNew.getInstance();

interface IStepChildrenProps extends WithStyles<typeof GuideStyles> {
    firstSchedule: boolean;
    step: number;
    progress?: number | undefined;
    setStep: (step: number) => void;
    setFChildren: (childrenIds: number[]) => void;
    toggleSnackBar: (state: boolean) => void;
    setStepErrorType: (type: string) => void;
    cancelCallback?: () => void | undefined;
    family:IFamilyMember[];
    style?:React.CSSProperties;
}

interface IStepChildState {
    cancelConfirm:boolean,
    formValues: {
        selectedChildren: number[];
    };
}

class StepChildrenComponent extends React.Component<IStepChildrenProps, IStepChildState> {
    constructor(props: IStepChildrenProps) {
        super(props);

        this.state = {
            cancelConfirm:false,
            formValues: {
                selectedChildren: props.family.filter((mem) => mem.role === FamilyMemberType.CHILD).map((mem) => mem.id),
            },
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    public componentDidUpdate(prevProps: Readonly<IStepChildrenProps>, prevState: Readonly<IStepChildState>, snapshot?: any): void {
        if (this.props.family.length !== prevProps.family.length) {
            this.setState({formValues: {selectedChildren:this.props.family.filter((mem) => 
                mem.role === FamilyMemberType.CHILD).map((mem) => mem.id)}});
        }
    }

    public render() {
        const {formValues} = this.state;
        const {classes: style, cancelCallback} = this.props;
        const children = this.props.family.filter((mem) => mem.role === FamilyMemberType.CHILD);

        return (
            <div className={style.container} style={this.props.style}>
                {this.props.progress && (
                    <div className={style.topBar}>
                        <ProgressBar value={this.props.progress}/>
                    </div>
                )}

                {this.state.cancelConfirm
                    ?<>
                        <div className={style.topContent}>
                            <Typography variant="h2">{tn.lang.newCalendarChildrenTitle}</Typography>
                            <Typography>
                                {tn.lang.newCalendarSureCancel}
                            </Typography>
                        </div>
                        <div className={style.formMiddleContentChildren} />
                        <div className={style.formBottomContent}>
                            <Button
                                onClick={() => this.setState({cancelConfirm:false})}
                                variant='contained'
                                color='primary'
                                size="large"
                                fullWidth={true}
                            >
                                {tn.lang.onBCreateSchedule}
                            </Button>
                            {cancelCallback && (
                                <Button
                                    type="button"
                                    variant='text'
                                    onClick={() => cancelCallback()}
                                >
                                    {tn.lang.onbBtnChooseLater}
                                </Button>
                            )}
                        </div>
                    </>
                    :<>
                        {this.props.firstSchedule && (
                            <div className={style.topContent}>
                                <Typography variant="h2">{tn.lang.newCalendarChildrenTitle}</Typography>
                                <Typography>
                                    {tn.lang.newCalendarChildrenMainText}
                                </Typography>
                            </div>
                        )}
                        <form className={style.formGuide} onSubmit={this.handleSubmit}>
                        <div className={style.formMiddleContentChildren}>
                            <Typography variant={this.props.firstSchedule?"body1":"h2"} className={this.props.firstSchedule?style.label:""}>
                                {tn.lang.newCalendarChildrenSubTitle}</Typography>
                            {(children && children.length) && children.map((child, index) => (
                                <CheckboxButton
                                    key={`selectedChildren.${child.id}`}
                                    id={`selectedChildren.${child.id}`}
                                    name={`selectedChildren.${child.id}`}
                                    readOnly={true}
                                    checked={formValues.selectedChildren.includes(child.id)}
                                    value={child.id}
                                    label={child.firstName}
                                    onClick={() => this.handleInputChange(child.id)}
                                />
                            ))}
                            <Typography style={this.state.formValues.selectedChildren.length===0?{}:{display:'none'}} 
                                className={style.errorMessage}>
                                    {tn.lang.CalendarTemplatesErrorChildren}
                            </Typography>
                        </div>
                        <div className={style.formBottomContent}>
                            <Button
                                type="submit"
                                variant='contained'
                                color='primary'
                                size="large"
                                fullWidth={true}
                            >
                                {tn.lang.continue}
                            </Button>
                            {cancelCallback && (
                                <Button
                                    type="button"
                                    variant='text'
                                    onClick={() => this.setState({cancelConfirm:true})}
                                >
                                    {tn.lang.onbBtnChooseLater}
                                </Button>
                            )}
                        </div>
                    </form>
                    </>
                }
            </div>
        );
    }

    private handleInputChange = (childId: number) => {

        const newList = [...this.state.formValues.selectedChildren];

        if (newList.includes(childId)) {
            newList.splice(newList.indexOf(childId),1);
        } else {
            newList.push(childId);

        }

        this.setState((prevState) => ({
            formValues: {
                selectedChildren:newList
            }
        }));
    }

    private handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        const {setFChildren, toggleSnackBar, setStepErrorType, setStep, firstSchedule} = this.props;
        const {formValues} = this.state;
        const isSelectedChildrenValid = (this.state.formValues.selectedChildren.length >= 1);

        if (isSelectedChildrenValid) {
            try {
                setFChildren(formValues.selectedChildren);
                setStep(firstSchedule ? 2 : 1);
            } catch (error) {
                toggleSnackBar(true);
                setStepErrorType(error);
            }
        }
    }
}

export default withStyles(GuideStyles)(StepChildrenComponent);



// WEBPACK FOOTER //
// ./src/components/guide/steps/stepChildren.component.tsx